import React from "react";
import { ProfileContainer } from "./style";
import IndividualForm from "./individualForm";
import LegalForm from "./legalForm";
import { updateProfile } from "api/auth";
import MainContext from "contexts/main";
import { toast } from "react-toastify";

const Profile = ({ nextStep }) => {
  const { user, setInformation } = React.useContext(MainContext);
  const [userType, setUserType] = React.useState(
    user?.profile.information?.user_type
      ? user?.profile.information?.user_type
      : "person"
  );
  const [loading, setLoading] = React.useState(false);
  const handleSubmit = (values) => {
    let data = {
      information: {
        ...values,
        user_type: userType,
      },
    };
    setLoading(true);
    updateProfile(data)
      .then((res) => {
        setLoading(false);
        setInformation(res.data.profile.information);
        toast.success("اطلاعات با موفقیت ثبت شد");
        nextStep();
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  return (
    <ProfileContainer>
      {/*<div className="type-selector">*/}
      {/*  <div*/}
      {/*    className={`item ${userType === "person" ? "active" : ""}`}*/}
      {/*    onClick={() => setUserType("person")}*/}
      {/*  >*/}
      {/*    حقیقی*/}
      {/*  </div>*/}
      {/*  <div*/}
      {/*    className={`item ${userType === "company" ? "active" : ""}`}*/}
      {/*    onClick={() => setUserType("company")}*/}
      {/*  >*/}
      {/*    حقوقی*/}
      {/*  </div>*/}
      {/*</div>*/}
      <div className="form-area">
        {userType === "person" ? (
          <IndividualForm
            onChange={handleSubmit}
            information={user?.profile.information}
            loading={loading}
          />
        ) : (
          <LegalForm
            onChange={handleSubmit}
            information={user?.profile.information}
            loading={loading}
          />
        )}
      </div>
    </ProfileContainer>
  );
};
export default Profile;
